import { Player$Source } from '@Ravnur-Inc/player/src/types/Source';

import BaseRepository from './base-repository';

import prepareSources, { prepareSource } from '@/transformers/player';
import { VideoSource } from '@/types/VideoSource';

export enum Source$Type {
  AUDIO = 'Audio',
  VIDEO = 'Video',
  VIDEO_PLAYLIST = 'VideoPlaylist',
  AUDIO_PLAYLIST = 'AudioPlaylist',
}

interface ServerSourceResponse {
  mediaSources: VideoSource[];
  mediaType: Source$Type;
}

if (process.env.VUE_APP_MOCK_API === 'yes') {
  (function _bootstrap() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const adapert = require('../mocks/index').default;
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const fnc = require('../mocks/sources').default;
    fnc(adapert);
  })();
}

export default class SourcesRepository extends BaseRepository<VideoSource> {
  constructor() {
    super('/source');
  }

  public async pull(id: string, preferHLS = true): Promise<Player$Source | Player$Source[]> {
    const resp = await super.get(id);
    // TODO: something went wrong with this any type
    const { mediaSources: s, mediaType }: ServerSourceResponse = resp as any;
    return isPlaylist(mediaType) ? prepareSources(s, preferHLS) : prepareSource(s[0], preferHLS);
  }
}

function isPlaylist(type: Source$Type) {
  return type === Source$Type.AUDIO_PLAYLIST || type === Source$Type.VIDEO_PLAYLIST;
}
